import React, { useState, useMemo, useContext, useEffect } from "react";
import Dialog from '@mui/material/Dialog';
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import DataTable from "react-data-table-component";
import Button from "components/CustomButtons/Button.js";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { equipmentalarmsstext } from "variables/MBM/equipments";
import { criticityData, closedData } from "variables/MBM/lists/equipments";
import Tooltip from "@mui/material/Tooltip";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { NotificationManager } from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "axios";
import UserService from "services/UserService";
import { deleteMBMEquipmentAlarms } from "services/ConfigServices";
import moment from "moment";
import 'moment/locale/fr';
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import CommentsDialog from "./CommentsDialog.js";
import AcquitmentDialog from "./AcquitmentDialog.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { width } from "@mui/system";

const useStyles2 = makeStyles(styles);


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  "@keyframes flicker": {
    from: {
      opacity: 1
    },
    to: {
      opacity: 0.7
    }
  },
  flicker: {
    animationName: "$flicker",
    animationDuration: "1000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out"
  },
  withAnimation: ({ disabled }) => ({
    animationPlayState: disabled ? "paused" : "running"
  })
}));

const Title = styled.div`
text-align: center;
margin-top: 21px;
font-size: 20px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 15px;
  font-weight: 400;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 15px;
  font-weight: 400;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  cursor: pointer;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  margin-bottom: 0.6rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const Data = styled.div`
font-size: 15px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
`;
const DataMargin = styled.div`
font-size: 15px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const LinkCell = styled.div`
  font-weight: 600;
  cursor: pointer;
`;
const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.1rem 1rem;
  margin-bottom: 0.6rem;
  
`;
const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};



function ViewEquipmentAlarmsDialog(props) {
  const currentusertype = localStorage.getItem('userType');
  const classes2 = useStyles2();
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_admin = permis.includes("mbm_geb_admin");
  const classes = useStyles();
  const { alarmsdata, refetch } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const [currentAlert, setCurrentAlert] = useState();
  const [commentOpen, setCommentOpen] = useState(false);
  const [acquitmentOpen, setAcquitmentOpen] = useState(false);
  const [hideclosed, setHideclosed] = useState(true);
  const [filteredAlarmsdata, setFilteredAlarmsdata] = useState([]);
  const { chartIdGroup } = advancedSearchContext;

  const handleHideclosedChange = (event) => {
    setHideclosed(!hideclosed);
  };

  const columns = [
    {
      name: equipmentalarmsstext.name,
      selector: row => row.alarmproperties?.title?.fr || "",
      sortable: true,
      //width: "11rem",
      cell: (row) => row.alarmproperties?.title?.fr || "",
    },
    {
      name: equipmentalarmsstext.starttimestamp,
      selector: row => row.starttimestamp,
      sortable: true,
      width: "10rem",
      cell: (row) => moment(row.starttimestamp).format("YYYY-MM-DD HH:mm"),
    },
    {
      name: equipmentalarmsstext.endtimestamp,
      selector: row => row.endtimestamp ? row.endtimestamp : 0,
      sortable: true,
      width: "10rem",
      cell: (row) =>
        row.endtimestamp ?
          moment(row.endtimestamp).format("YYYY-MM-DD HH:mm")
          : <></>
    },
    {
      name: equipmentalarmsstext.criticity,
      selector: row => row.alarmproperties?.criticity || "",
      sortable: true,
      width: "9rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => criticityData.find((x) => x.id == row.alarmproperties?.criticity)?.name || ""
    },
    {
      name: equipmentalarmsstext.value,
      selector: row => row.value,
      sortable: true,
      // width: "10rem",
      cell: (row) => row.value,
    },
    {
      name: equipmentalarmsstext.acquited,
      key: "acquited",
      selector: row => row.acquitment ? row.acquitment.acquited : 'no',
      sortable: true,
      width: "7rem",
      cell: (row) => <div style={ mbm_geb_admin ? { cursor: 'pointer' }:{}} onClick={mbm_geb_admin ? acquitment(row) : ""}>
        {(row.acquitment?.acquited && row.acquitment.acquited === "yes") ? (
          <div>{equipmentalarmsstext.yes}</div>
        ) : (
          <div>{equipmentalarmsstext.no}</div>
        )}
      </div>
      ,
    },
    {
      name: equipmentalarmsstext.closed,
      selector: row => row.closed,
      sortable: true,
      width: "7rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => closedData.find((x) => x.id == row.closed)?.name || ""
    },
    {
      name: equipmentalarmsstext.comments,
      selector: row => row.comments ? row.comments.length : 0,
      sortable: true,
      cell: (row) => <div style={{ cursor: 'pointer' }} onClick={comment(row)}>{(row.comments && row.comments.length > 0) ? (row.comments.length + ' ' + equipmentalarmsstext.commentsvar) : equipmentalarmsstext.nocomments}</div>,
      //width: "7rem"
    },
    {
      name: "Actions",
      sortable: false,
      width: "6rem",
      cell: (row) => (
        <>
          {
            mbm_geb_admin ?
              <div className="actions-right">
                <Tooltip title={equipmentalarmsstext.deletealert}>
                  <CustomDeleteButton
                    deleteTitle={equipmentalarmsstext.deletealert}
                    deleteSubTitle={equipmentalarmsstext.confirmdelete}
                    handleSupprimer={deleteAlertFunction(row)}
                  />
                </Tooltip>
              </div>
              : <></>
          }
        </>
      ),
    },
  ];

  const handleClickCommentOpen = () => {
    setCommentOpen(true);
  };
  const handleClickCommentClose = () => {
    setCommentOpen(false);
  };
  const handleClickAcquitmentOpen = () => {
    setAcquitmentOpen(true);
  };
  const handleClickAcquitmentClose = () => {
    setAcquitmentOpen(false);
  };
  const comment = (row) => async () => {
    let obj = alarmsdata.find((o) => o.id === row.id);
    if (obj) {
      setCurrentAlert(obj);
      handleClickCommentOpen();
    }
  };
  const acquitment = (row) => async () => {
    let obj = alarmsdata.find((o) => o.id === row.id);
    if (obj) {
      setCurrentAlert(obj);
      handleClickAcquitmentOpen();
    }
  };

  const deleteAlertFunction = (row) => async () => {
    let obj = alarmsdata.find((o) => o.id === row.id);
    let idSelected = obj.id;
    axios
      .delete(deleteMBMEquipmentAlarms(idSelected),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        })
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success(equipmentalarmsstext.deleted);
          refetch();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const [resetPaginationToggleEquipment, setResetPaginationToggleEquipment] = useState(false);

  useEffect(() => {
    if (hideclosed) {
      setFilteredAlarmsdata(alarmsdata.filter((al) => (!al.closed && !al.acquitment?.acquited)));
    }
    else
      setFilteredAlarmsdata(alarmsdata);
  }, [hideclosed, alarmsdata, refetch]);

  const subHeaderComponentMemo = useMemo(() => {

    return (
      <>
        <CustomSwitch
          style={{ margin: "10px 40px 0 3px" }}
          inputTitle={equipmentalarmsstext.hideclosed}
          checkedState={hideclosed}
          handleSwitchChange={handleHideclosedChange}
        />
      </>
    );
  }, [hideclosed]);

  return (
    <>
      <DialogContent>
        <form className={classes.root}>
          <GridContainer>
            <GridItem style={{ width: '100%' }}>
              <DataTable
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                noDataComponent={<NoData>{"Aucune alarme"}</NoData>}
                noHeader={true}
                columns={columns}
                persistTableHead
                pagination
                subHeader
                data={filteredAlarmsdata}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rowsPerPageText: "Lignes par page",
                  rangeSeparatorText: "sur",
                  selectAllRowsItem: false,
                  selectAllRowsItemText: "Selectionner toutes les lignes",
                }}
                defaultPageSize={10}
                filterable={true}
                defaultSortFieldId={2}
                defaultSortAsc={false}
                manual={true}
                paginationResetDefaultPage={resetPaginationToggleEquipment}
                subHeaderComponent={subHeaderComponentMemo}
                pointerOnHover={false}
                subHeaderAlign={"left"}
              />
            </GridItem>
          </GridContainer>
        </form>
      </DialogContent>
      <Dialog
        onClose={handleClickCommentClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={commentOpen}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickCommentClose}>
          {equipmentalarmsstext.comments}
        </CustomDialogTitle>
        <DialogContent dividers>
          <CommentsDialog
            currentAlert={currentAlert}
            closeModal={handleClickCommentClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClickAcquitmentClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={acquitmentOpen}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickAcquitmentClose}>
          {equipmentalarmsstext.acquitment}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AcquitmentDialog
            currentAlert={currentAlert}
            closeModal={handleClickAcquitmentClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
}

export default ViewEquipmentAlarmsDialog;
